module.exports = __webpack_public_path__ + "resources/img/img_security_ahnlab_vaips_m_en.517e062571d31425c9f01f105620c691.png";